import { BaseContainerModel } from '../base-container.model';
import { bl_mrp_pi_worklog_historical_Rowclass } from '../../dbschema';

export class MrpWorklogHistoricalContainer extends BaseContainerModel {
  bl_mrp_pi_worklog_historical: bl_mrp_pi_worklog_historical_Rowclass
    = new bl_mrp_pi_worklog_historical_Rowclass();
}
